import JoiSchema from "./JoiSchema";
import YupSchema from "./yupSchema";
class SchemaFactory {
  constructor(schemaType) {
    if (schemaType == "Joi") return new JoiSchema();
    else if (schemaType == "Yup") return new YupSchema();
  }
}
export default SchemaFactory;
